/* eslint-disable import/prefer-default-export */
import MessageSender from '../sender'
import BaseMessage from '../message'

export const postWhitelistIpLogin =
  (otp, idOtp, captcha, type, ipAddress, isActive, idIp) => async () => {
    const msg = new BaseMessage()

    msg.setPath('/control/whitelist_ip_login')
    msg.setItem('id_otp', idOtp)
    msg.setItem('otp', otp)
    msg.setItem('captcha', captcha)
    msg.setItem('type', type)
    msg.setItem('ipAddress', ipAddress)
    msg.setItem('isActive', isActive)
    msg.setItem('id_ip', idIp)

    const response = await new MessageSender().doPost(msg)

    return response
  }

export const getWhitelistIpLoginByID = (id) => async () => {
  const msg = new BaseMessage()
  msg.setPath(`data/whitelist_ip_login_detail`)
  msg.setItem('id', id)

  const response = await new MessageSender().doGet(msg)

  return response
}
